import { object, string } from 'yup';

export interface UserFormProps {
  email: string;
  first_name: string;
  last_name: string;
  password: string;
  passwordCompare: string;
  role: string;
}

export enum UserType {
  CompanyAlias = 'company_alias',
  NotSet = 'not_set',
  Supervisor = 'supervisor'
}
// enum('not_set','common','supervisor','company','company_alias','admin')

export const UserFormSchema = object().shape({
  email: string()
    .email('errors.email is not valid')
    .required('errors.email is required'),
  first_name: string().required('errors.first name is required'),
  last_name: string().required('errors.last name is required'),
  password: string()
    .min(8, 'errors.password is too short')
    .required('errors.password is required'),
  passwordCompare: string()
    .min(8, 'errors.password is too short')
    .required('errors.password is required')
    .test(
      'password',
      'errors.password must be confirmed',
      /* eslint-disable func-names */ function(passwordCompare) {
        return passwordCompare === this.parent.password;
      }
    ),
  role: string().required('errors.role is required')
});

export const UpdateUserSchema = object().shape({
  email: string()
    .email('errors.email is not valid')
    .required('errors.email is required'),
  first_name: string().required('errors.first name is required'),
  last_name: string().required('errors.last name is required'),
  role: string().required('errors.role is required')
});

export const UpdateUserPasswordSchema = object().shape({
  password: string()
    .min(8, 'errors.password is too short')
    .required('errors.password is required'),
  passwordCompare: string()
    .min(8, 'errors.password is too short')
    .required('errors.password is required')
    .test(
      'password',
      'errors.password must be confirmed',
      /* eslint-disable func-names */ function(passwordCompare) {
        return passwordCompare === this.parent.password;
      }
    )
});
